import { privateAxios } from '../axiosInstances';
import { PdfJobStatus } from "@prisma/client";
import { useQuery } from "@tanstack/react-query";
import { pdfJobsQueryKeys } from "../query-keys/pdf-jobs.query-keys";

const fetchJobs = async (jobType: PdfJobStatus) => {
  const { data } = await privateAxios.get(`/pdf-jobs/${jobType}-jobs`);
  return data;
};

export const useGetPdfJobs = (jobType: PdfJobStatus) => {
  return useQuery({
    queryKey: pdfJobsQueryKeys.get(jobType),
    queryFn: () => fetchJobs(jobType),
    refetchInterval: 1000 * 60,
  });
};
